var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52.5,
    fill: "#E9E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.079 35.0982C28.8757 34.125 29.4998 33.1714 30.4729 32.9681L73.0152 24.0819C73.9883 23.8787 74.9419 24.5027 75.1452 25.4759L87.5803 85.0084L41.5141 94.6307L29.079 35.0982Z",
    fill: "#44179B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5936 37.5902C26.9271 34.3991 28.9736 31.2719 32.1646 30.6054L70.5269 22.5923C73.718 21.9257 76.8452 23.9722 77.5118 27.1633L88.7058 80.754C89.3723 83.945 87.3258 87.0722 84.1347 87.7388L45.7724 95.7519C42.5814 96.4184 39.4542 94.3719 38.7876 91.1808L27.5936 37.5902ZM32.9692 34.4573C31.9056 34.6795 31.2234 35.7219 31.4456 36.7856L42.6396 90.3763C42.8618 91.4399 43.9042 92.1221 44.9678 91.8999L83.3301 83.8868C84.3938 83.6646 85.076 82.6222 84.8538 81.5585L73.6598 27.9679C73.4376 26.9042 72.3952 26.222 71.3315 26.4442L32.9692 34.4573Z",
    fill: "url(#paint0_linear_325_51413)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.795 51.574C102.402 50.759 102.159 49.596 101.276 49.0922L88.7841 41.9665C88.3572 41.723 87.9008 41.6877 87.4946 41.8026L83.6411 42.6075L84.3831 46.1596L68.1139 49.5579L71.2187 64.4218L87.4879 61.0235L88.2875 64.536L91.8763 63.7864C92.3656 63.7794 92.8574 63.5633 93.1994 63.1044L101.795 51.574Z",
    fill: "#DC466D",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.943 52.3785C98.5506 51.5634 98.3076 50.4004 97.4246 49.8967L84.9326 42.771C83.6656 42.0483 82.1389 43.1595 82.4371 44.5873L82.8331 46.4833L64.2623 50.3624L67.3671 65.2262L85.9379 61.3472L86.334 63.2434C86.6322 64.6711 88.4761 65.0783 89.3478 63.9089L97.943 52.3785Z",
    fill: "#F56087",
    stroke: "black",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0909 35.388L61.0949 22.8417C62.1379 22.4055 63.3201 23.0276 63.5512 24.1343L77.6786 91.768C77.9097 92.8747 77.0754 93.918 75.945 93.9358L43.4276 94.4489L31.0909 35.388Z",
    fill: "#44179B",
    stroke: "black",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0909 35.388L58.5558 23.4121C59.6023 22.9558 60.8038 23.5765 61.0372 24.6941L75.1507 92.2614C75.3841 93.379 74.5316 94.4287 73.3899 94.4295L43.4276 94.4489L31.0909 35.388Z",
    fill: "url(#paint1_linear_325_51413)",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4267 40.5493C35.3686 40.2711 35.5137 39.9902 35.7742 39.8766L58.1685 30.1118C58.5173 29.9597 58.9178 30.1666 58.9956 30.5391L70.9399 87.7215C71.0177 88.094 70.7335 88.444 70.353 88.4442L45.9223 88.46C45.6381 88.4602 45.3927 88.2609 45.3346 87.9827L35.4267 40.5493Z",
    stroke: "#8A64FF",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1202 54.5573L56.8842 55.2333C56.5598 55.301 56.3518 55.6189 56.4196 55.9433L58.4103 65.4736C58.478 65.798 58.7959 66.006 59.1203 65.9383L62.3562 65.2623",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3017,
    cy: 52.2348,
    r: 1.36811,
    fill: "#611FE2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.9033,
    cy: 73.226,
    r: 1.36811,
    fill: "#611FE2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4931,
    cy: 41.8725,
    r: 1.36811,
    fill: "#611FE2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3001,
    cy: 42.528,
    r: 2.49538,
    fill: "#611FE2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4094,
    cy: 36.763,
    r: 2.49538,
    fill: "#611FE2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5188,
    cy: 99.4541,
    r: 2.49538,
    fill: "#611FE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8643 84.6551C31.0293 90.5993 39.1402 92.1007 44.9805 88.0085C50.8209 83.9163 52.179 75.7802 48.014 69.836C43.849 63.8918 35.7381 62.3904 29.8978 66.4825C24.0575 70.5747 22.6993 78.7108 26.8643 84.6551ZM29.0656 83.1125C32.3636 87.8194 38.786 89.0082 43.4106 85.7679C48.0351 82.5276 49.1105 76.0852 45.8126 71.3783C42.5146 66.6715 36.0922 65.4827 31.4676 68.723C26.8431 71.9633 25.7676 78.4057 29.0656 83.1125Z",
    fill: "#A925C3",
    stroke: "black",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.631 83.0723C32.796 89.0165 40.5499 90.7681 45.9498 86.9845C51.3497 83.2009 52.3509 75.3149 48.1859 69.3707C44.0209 63.4264 36.267 61.6749 30.8671 65.4585C25.4671 69.2421 24.466 77.1281 28.631 83.0723Z",
    fill: "#B936D3",
    stroke: "black",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4343 79.7384C39.8458 80.0784 39.093 79.877 38.7529 79.2885C38.4384 78.7443 38.2552 78.2353 38.2031 77.7613C38.1574 77.2635 38.18 76.7968 38.271 76.3611C38.3684 75.9016 38.5027 75.4711 38.674 75.0697C38.8366 74.6531 38.9808 74.2572 39.1068 73.882C39.2391 73.483 39.3054 73.0918 39.3057 72.7085C39.3212 72.3165 39.2241 71.9391 39.0144 71.5763C38.9183 71.4101 38.7865 71.2342 38.6189 71.0488C38.4512 70.8634 38.2351 70.7161 37.9704 70.607C37.712 70.474 37.4043 70.43 37.0473 70.475C36.6815 70.5049 36.2643 70.6553 35.7957 70.9261C35.2818 71.223 34.9098 71.5388 34.6797 71.8734C34.4647 72.1992 34.344 72.5311 34.3175 72.869C34.2974 73.1831 34.3313 73.4861 34.4193 73.778C34.7117 74.5807 34.5473 75.4884 33.8076 75.9159L33.5939 76.0394C32.7361 76.5351 31.6129 76.2548 31.1724 75.3674C31.0117 75.0437 30.8835 74.7459 30.8404 74.5456C30.7359 73.9809 30.7256 73.4223 30.8096 72.8698C30.8999 72.2933 31.1008 71.7337 31.4121 71.1908C31.7147 70.6329 32.1247 70.1036 32.6419 69.6031C33.1592 69.1026 33.7882 68.6383 34.5288 68.2103C35.1637 67.8435 35.7881 67.5633 36.4021 67.3697C37.0226 67.1524 37.6143 67.0423 38.1772 67.0396C38.7466 67.013 39.2785 67.0787 39.773 67.2365C40.2675 67.3944 40.7245 67.6444 41.144 67.9867C41.5636 68.329 41.9263 68.7646 42.232 69.2937C42.6163 69.9587 42.8456 70.5823 42.9198 71.1645C42.9854 71.7315 42.9599 72.2805 42.8434 72.8116C42.7332 73.3188 42.5786 73.8014 42.3794 74.2592C42.1802 74.7171 41.9962 75.1662 41.8272 75.6066C41.6647 76.0231 41.5681 76.4318 41.5376 76.8325C41.5307 76.9223 41.5496 77.0452 41.5857 77.1865C41.8113 78.0692 41.586 79.0729 40.7971 79.5287L40.4343 79.7384ZM43.4472 84.1671C42.5706 84.6736 41.4494 84.3737 40.9429 83.4971C40.4364 82.6206 40.7364 81.4994 41.6129 80.9929L41.6583 80.9667C42.5348 80.4602 43.656 80.7601 44.1625 81.6367C44.669 82.5132 44.3691 83.6344 43.4925 84.1409L43.4472 84.1671Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_325_51413",
    x1: 51.3458,
    y1: 26.5988,
    x2: 64.9536,
    y2: 91.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875FFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_325_51413",
    x1: 50.3154,
    y1: 30.3049,
    x2: 26.3969,
    y2: 66.8524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D85FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutImg);
export default __webpack_public_path__ + "static/media/logout-img.56b237a0571d985edc9e701617059cc5.svg";
export { ForwardRef as ReactComponent };